import type { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

interface AuthFormProps extends HTMLAttributes<HTMLFormElement> {
  children: ReactNode;
}

export const AuthForm = ({ children, ...props }: AuthFormProps) => {
  return <Form {...props}>{children}</Form>;
};

const Form = styled.form`
  border: 1px solid ${({ theme }) => theme.getColor('gray', '04')};
  display: flex;
  flex-direction: column;
  min-width: 60rem;
  padding: 2.4rem;
  border-radius: 0.8rem;
`;
